import { render, staticRenderFns } from "./JAlert.vue?vue&type=template&id=ce31e1de&scoped=true"
import script from "./JAlert.vue?vue&type=script&lang=js"
export * from "./JAlert.vue?vue&type=script&lang=js"
import style0 from "./JAlert.vue?vue&type=style&index=0&id=ce31e1de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce31e1de",
  null
  
)

export default component.exports